import React from 'react';
import { UserOutlined } from '@ant-design/icons';

const VoteAuthModal = ({
  open,
  accountName,
  bankLastFourDigits,
  bankDigitRefs,
  isSubmittingVote,
  onAccountNameChange,
  onBankDigitChange,
  onBankDigitKeyDown,
  onClose,
  onConfirm
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/55 px-3">
      <div className="w-full max-w-[440px] rounded-[24px] ring-[2px] ring-[#1B9938] bg-gradient-to-b from-[#d7e6da] to-[#d7e6da] p-3.5 shadow-[0_14px_28px_rgba(0,44,80,0.45)]">
        <div className="space-y-3">
          <h3 className="text-center text-[19px] font-extrabold uppercase text-[#1B9938]">
            KIỂM TRA THÔNG TIN
          </h3>

          <div>
            <label htmlFor="vote-account-name" className="mb-1.5 block text-[17px] font-medium text-[#1f2b36]">
              Tên tài khoản
            </label>
            <div className="flex h-[46px] items-center gap-3 rounded-[15px] bg-[#f7f7f9] px-4 shadow-[0_2px_0_#9bc2d8]">
              <UserOutlined className="text-[20px] text-[#1B9938]" />
              <input
                id="vote-account-name"
                type="text"
                value={accountName}
                onChange={(e) => onAccountNameChange(e.target.value)}
                placeholder="Vui lòng nhập tên tài khoản"
                className="h-full w-full border-0 bg-transparent text-[17px] text-[#363b43] outline-none placeholder:text-[#848484]"
              />
            </div>
          </div>

          <div>
            <label className="mb-1.5 block text-[17px] font-medium text-[#1f2b36]">
              4 số cuối tài khoản liên kết ngân hàng
            </label>
            <div className="grid grid-cols-4 gap-3">
              {[0, 1, 2, 3].map((idx) => {
                const currentDigit = bankLastFourDigits[idx] || '';
                return (
                  <input
                    key={`bank-digit-${idx}`}
                    ref={(el) => {
                      bankDigitRefs.current[idx] = el;
                    }}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={currentDigit}
                    onChange={(e) => onBankDigitChange(idx, e.target.value)}
                    onKeyDown={(e) => onBankDigitKeyDown(idx, e)}
                    placeholder="-"
                    className="h-[46px] rounded-[15px] border-0 bg-[#f7f7f9] text-center text-[18px] text-[#363b43] shadow-[0_2px_0_#9bc2d8] outline-none placeholder:text-[#4f4f4f]"
                  />
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmittingVote}
              className="h-[46px] cursor-pointer rounded-[12px] border-0 bg-[#c7e0cc] text-[17px] font-bold uppercase text-[#1d1d1d] outline-none transition duration-200 hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60"
            >
              HỦY
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmittingVote}
              className="h-[46px] cursor-pointer rounded-[12px] border-0 bg-gradient-to-b from-[#00CD32] to-[#048724] text-[17px] font-bold uppercase text-white shadow-[inset_0_-2px_0_#2CF65D] transition duration-200 hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {isSubmittingVote ? 'ĐANG GỬI...' : 'XÁC NHẬN'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoteAuthModal;
